module.exports = __webpack_public_path__ + "static/acknowledgment-of-country-888ad38c9bf723a5d50caaf58efe812f.png";